import React from 'react'
import {
  Button,
  Form,
  Input,
  Modal,
  Col,
  Row,
  Table,
  Pagination,
  Space,
  message,
  ConfigProvider,
  InputNumber,
  List, Switch
} from 'antd'
import {
  Link,
} from "react-router-dom";
import {CheckOutlined,OrderedListOutlined} from '@ant-design/icons';
import {ReactSortable} from "react-sortablejs";
import copy from 'copy-to-clipboard';
import './index.less'
import zhCN from "antd/es/locale/zh_CN";

import {removeToken} from '../../utils/cookie'
import {
  getProductChangeStatus,
  getCategorieList,
  getProductList,
  getCategorieSave,
  getCategorieInfo,
  getHistoryList,
  getProductOnshelfBatch,
  getProductOffshelfBatch,
  getProductStock,
  getProductStockBatch,
  getProductPrice,
  getRecommend,
  noRecommend
} from '../../constants/api'

import {COMMON_ROUTER} from "../../constants";

export default class Goods extends React.Component {

  state = {
    shopId: 0,//门店ID

    tempCategoryId: 0,//选中分类ID
    category: [],//分类数据
    tempDelCategoryId: 0,//删除分类ID

    delCate1Visible: false,//分类删除弹窗1
    delCateVisible: false,//分类删除弹窗2
    visible: false,//新建分类弹窗显示隐藏
    categoryName: '',//新建、编辑分类弹窗输入名称
    categoryDesc: '',//新建、编辑分类弹窗输入描述
    sortNum: 0,//新建、编辑分类弹窗输入排序号

    onShelfVisible: false, //上架的模态框
    soldOutVisible: false, //下架的模态框
    deleteVisible: false,//删除模态框
    xmCategoryIdOption: 0, //操作的商品分类ID
    productIdOption: 0,//操作的商品ID

    categoryProduct: [],//右侧商品数据
    //右侧商品分页
    current: 1,
    total: 0,
    pageSize: 10,
    selectedRowKeys: [], //多选商品

    tempSaveCategoryId: 0, //编辑时存储分类id

    modalType: '新建分类',//新建、编辑分类弹窗标题

    inputProductCode: '',//搜索商品码
    inputProductName: '',//搜索商品名称

    isSort: false,//是否点击排序
    loadingSort: false,//排序保存加载

    bigImgVisible: false, //大图弹窗
    bigImgUrl: '',//大图URL

    logVisible: false,//log弹窗
    logList: [],
    logTotal: 0,
    logCurrent: 1,
    logPagesize: 10,

    sortProductVisible: false,//商品排序选择店

    tempProductStock: 0,//修改单个库存
    updateStockVisible: false,//批量改库存
    inputProductStock: '',//修改库存弹窗

    tempProductPrice: 0,//修改单个价格
  }

  componentWillMount() {
    if (this.props.location.state) {
      this.setState({
        tempCategoryId: this.props.location.state.tempCategoryId
      })
    }
  }

  componentDidMount() {
    this.getShopId()
  }

  getShopId = () => {
    let storage = window.localStorage;
    let shopId = storage.getItem('SHOP_ID');
    if (shopId) {
      this.setState({
        shopId: shopId,
      }, () => {
        this.searchCategory(shopId);
      })
    }
  }

  //根据门店ID查询商品分类
  searchCategory(id) {
    const _this = this;
    getCategorieList({
      pageIndex: 1,
      pageSize: 100,
      sortName: "",
      sortType: "",
      id: id,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        // console.log(data)
        if (data.code === 0) {
          if (data.data != null) {
            let categorys = data.data.records
            if (categorys.length > 0) {
              _this.setState({
                category: data.data.records,
                tempCategoryId: data.data.records[0].categoryId
              }, () => {
                // _this.searchProductById(1, data.data.records[0].categoryId, '', '', _this.state.pageSize)
                if (_this.state.tempCategoryId) {
                  _this.searchProductById(1, _this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, _this.state.pageSize)
                } else if (data.data.records.length > 0) {
                  _this.searchProductById(1, data.data.records[0].categoryId, this.state.inputProductName, this.state.inputProductCode, _this.state.pageSize)
                }
              });
            }
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  //根据商品分类ID查询商品列表
  searchProductById(current, categorieId, name, barCode, pageSize) {
    this.setState({tempCategoryId: categorieId, isSort: false});
    const _this = this;
    getProductList({
      categoryId: categorieId,
      pageIndex: current,
      pageSize: pageSize,
      sortName: "",
      sortType: "",
      shopId: this.state.shopId,
      productName: name,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            categoryProduct: data.data.records,
            total: data.data.total,
            current: data.data.current
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  onChangePage(page, pageSize) {
    this.setState({current: page}, () => {
      this.searchProductById(page, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
    })
  }
  onChangePageSize(page, pageSize) {
    this.setState({current: page, pageSize: pageSize}, () => {
      this.searchProductById(page, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, pageSize)
    })
  }

  /**
   * 修改分类弹窗的输入框值
   * @param e 修改结果
   */
  changeCategory = e => {
    const {value} = e.target;
    this.setState({categoryName: value})
  }
  changeCategoryDetail = e => {
    const {value} = e.target;
    this.setState({categoryDesc: value})
  }

  /**
   * 修改商品状态
   * @param flag 0下架 1上架
   */
  changeGoodsUpDown = (flag, productId) => {
    getProductChangeStatus({
      id: productId,
      dataStatus: flag
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.searchProductById(this.state.current, this.state.xmCategoryIdOption, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
          if (flag == 0) {
            message.success('下架成功')
          } else {
            message.success('上架成功')
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }
  /**
   * 修改商品状态
   * @param flag -100删除
   */
  changeGoods = () => {
    getProductChangeStatus({
      id: this.state.productIdOption,
      dataStatus: -100
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            deleteVisible: false
          }, () => {
            this.searchProductById(this.state.current, this.state.xmCategoryIdOption, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
            message.success('删除成功')
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
          this.setState({
            deleteVisible: false
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  onSelectChange = selectedRowKeys => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({selectedRowKeys});
    // message.success('当前选中' + selectedRowKeys.length + '个')
  };

  showModal = () => {
    this.setState({
      visible: true,
      categoryName: '',
      categoryDesc: '',
      sortNum: '',
      modalType: "新建分类"
    });
  };

  /**
   * 新建、编辑分类确认
   */
  handleOk = () => {
    let categorieId = 0;
    if (this.state.modalType == '新建分类') {
      categorieId = 0
    } else {
      categorieId = this.state.tempSaveCategoryId
    }

    const _this = this;
    getCategorieSave({
      categoryId: categorieId,
      sortNum: this.state.sortNum,
      categoryName: this.state.categoryName,
      description: this.state.categoryDesc,
      shopId: this.state.shopId,
      isDelete: 0
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            visible: false,
          }, ()=>{
            message.success('操作成功')
            _this.searchCategory(_this.state.shopId)
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          _this.setState({
            visible: false,
          })
          message.error(data.msg)
        }
      }
    }).catch(error => {
      _this.setState({
        visible: false,
      })
      message.error(error.toString())
    })
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  onHandleOk = (type) => {
    console.log(type)
    switch (type) {
      case 'delete1':
        this.setState({
          delete1Visible: false,
          deleteVisible: true,
        })
        break;
      case 'delete':
        this.changeGoods();
        break;
      default:
        break;
    }
  }
  onHandleCancel = (type) => {
    switch (type) {
      case 'delete1':
        this.setState({
          delete1Visible: false
        })
      case 'delete':
        this.setState({
          deleteVisible: false
        })
        break;
      default:
        break;
    }
  }

  /**
   * 上架 下架 删除
   * @param type 类型
   * @param xmCategoryId 分类id
   * @param productId 商品id
   */
  onShowModal = (type, xmCategoryId, productId) => {
    this.setState({
      xmCategoryIdOption: xmCategoryId,
      productIdOption: productId,
    })
    switch (type) {
      case 'onShelf':
        this.changeGoodsUpDown(1, productId)
        break;
      case 'soldOut':
        this.changeGoodsUpDown(0, productId)
        break;
      case 'delete':
        this.setState({
          // deleteVisible: true
          delete1Visible: true
        })
        break;
      default:
        break;
    }
  }

  /**
   * 删除分类
   * @param xmCategoryId 分类id
   */
  onShowDelCateModal = (xmCategoryId) => {
    this.setState({
      tempDelCategoryId: xmCategoryId,
      delCateVisible: true,
    })
  }
  onHandleDelCateOk = () => {
    this.setState({
      loadingDelCate: true
    }, () => {
      this.deleteCategory()
    })
  }
  onHandleDelCateCancel = () => {
    this.setState({
      delCateVisible: false
    })
  }
  deleteCategory = () => {
    getCategorieSave({
      categoryId: this.state.tempDelCategoryId,
      sortNum: this.state.sortNum,
      categoryName: this.state.categoryName,
      description: this.state.categoryDesc,
      shopId: this.state.shopId,
      isDelete: 1
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            delCateVisible: false,
            loadingDelCate: false
          }, () => {
            message.success('操作成功')
            this.searchCategory(this.state.shopId);
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          this.setState({
            delCateVisible: false,
            loadingDelCate: false
          }, () => {
            message.error(data.msg)
            this.searchCategory(this.state.shopId);
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }
  /*排序序号的添加*/
  changeSort = (e) => {
    this.setState({
      sortNum: e.target.value
    })
  }

  /**
   * 编辑分类
   * @param xmCategoryId 分类id
   */
  onShowEditCateModal = (xmCategoryId) => {
    this.getCategoryInfo(xmCategoryId);
  }
  getCategoryInfo = (xmCategoryId) => {
    getCategorieInfo({
      id: xmCategoryId,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            sortNum: data.data.sortNum,
            categoryName: data.data.categoryName,
            categoryDesc: data.data.description,
          }, () => this.setState({
            tempSaveCategoryId: xmCategoryId,
            visible: true,
            modalType: "编辑分类"
          }))
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  changeInputName = e => {
    const {value} = e.target;
    this.setState({inputProductName: value})
  }

  showSortSave = () => {
    const _this = this;
    _this.setState({sortProductVisible: true})
  };
  showSort = () => {
    this.setState({
      isSort: true,
    });
  };
  hideSort = () => {
    this.setState({
      isSort: false,
    });
  };
  sortFirst = (item, index) => {
    const sortProducts = [...this.state.categoryProduct]
    sortProducts.splice(index, 1)
    sortProducts.unshift(item)
    this.setState({categoryProduct: sortProducts})
  }
  onPressEnterSort = (item, index, e) => {
    // console.log(e.target.value)
    // console.log(e.target.value - 1)
    const sortProducts = [...this.state.categoryProduct]
    sortProducts.splice(index, 1)
    sortProducts.splice(e.target.value - 1, 0, item);
    this.setState({categoryProduct: sortProducts})
  }
  onChangeInputSort = (value) => {
    // console.log('changed', value);
  }

  onChangeSort = (pagination, filters, sorter, extra) => {
    // console.log('params', pagination, filters, sorter, extra);
    this.setState({categoryProduct: extra.currentDataSource})
  }

  showBigImg = (imageUrl) => {
    this.setState({bigImgVisible: true, bigImgUrl: imageUrl})
  }
  onHandleImgOk = (e) => {
    this.setState({
      bigImgVisible: false,
    });
  }
  onHandleImgCancel = (e) => {
    this.setState({
      bigImgVisible: false,
    });
  }

  getLogs = (current, size) => {
    const _this = this
    getHistoryList({
      pageIndex: current,
      pageSize: size,
      sortName: "",
      sortType: "",
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            logList: data.data.records,
            logTotal: data.data.total
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }
  showLog = () => {
    this.setState({
      logVisible: true,
    }, ()=>{
      this.getLogs(1, this.state.logPagesize)
    });
  }
  onHandleLogOk = (e) => {
    this.setState({
      logVisible: false,
    });
  }
  onHandleLogCancel = (e) => {
    this.setState({
      logVisible: false,
    });
  }
  onChangePageLog = (page, pageSize) => {
    this.setState({logCurrent: page}, ()=>{
      this.getLogs(page, this.state.logPagesize)
    })
  }

  onChangeSizeLog = (current, size) => {
    this.setState({logPagesize: size})
  }

  onBlurShelfNumber = (type, record, e) =>{
    // console.log('blur-----------------');
    let rows = this.state.categoryProduct
    let row = rows.find(item => item.productId === record.productId);
    if (row) {
      if (type == 'stock') {
        if (row.stock === e.target.value) {
        } else {
          row.stock = e.target.value
          this.setTextChange(row)
        }
      } else if (type == 'price') {
        if (row.price === e.target.value) {
        } else {
          row.price = e.target.value
          this.setTextChange2(row)
        }
      }
    }
  }

  onTextChange = (type, record, e) => {
    if (e.keyCode == 13) {
      let rows = this.state.categoryProduct
      let row = rows.find(item => item.productId === record.productId);
      if (row) {
        if (type == 'stock') {
          row.stock =e.target.value
          this.setTextChange(row)
        } else if (type == 'price') {
          row.price =e.target.value
          this.setTextChange2(row)
        }
        // row.countNum = e.target.value;
      }
    }
  }

  setTextChange = (row) => {
    getProductStock({
      productId: row.productId,
      shopId: this.state.shopId,
      stockCount: row.stock,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success("库存修改成功", 1)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }
  setTextChange2 = (row) => {
    getProductPrice({
      productId: row.productId,
      shopId: this.state.shopId,
      price: row.price,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success("价格修改成功", 1)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  copy = (content) => {
    // console.log(content)
    if (copy(content)) {
      message.success('复制成功')
    }
  }

  afterCloseModal = () => {
  }

  onHandleDelOk = ()=> {
    this.setState({deleteVisible: false})
  }
  onHandleDelCancel = ()=> {
    this.setState({deleteVisible: false})
  }

  onHandleDelBatchOk = () => {
    this.setState({deleteProductBatchVisible: false})
  }
  onHandleDelBatchCancel = () => {
    this.setState({deleteProductBatchVisible: false})
  }
  addShop=()=>{
    if (this.state.category==null||this.state.category.length==0){
      message.warn('请先创建分类')
    }else {
      this.props.history.push({
        pathname: COMMON_ROUTER + `/goods/add-goods`,
        state: {
          shopId: this.state.shopId,
          xmCategoryId: this.state.tempCategoryId,
          tempCategoryId: this.state.tempCategoryId
        }
      })
    }
  }

  onBathShelfSoldout = (type) => {
    switch (type) {
      case 'onShelf':
        getProductOnshelfBatch({
          ids: this.state.selectedRowKeys,
          shopId: this.state.shopId
        }).then((res) => {
          if (res.status === 200) {
            let data = res.data
            if (data.code === 0) {
              this.searchProductById(this.state.current, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
              message.success('上架成功')
            } else if (data.code === 50) {
              message.error(data.msg)
              removeToken();
            } else {
              message.error(data.msg)
              this.setState({
                deleteVisible: false
              })
            }
          }
        }).catch(error => {
          message.error(error.toString())
        })
        break;
      case 'soldOut':
        getProductOffshelfBatch({
          ids: this.state.selectedRowKeys,
          shopId: this.state.shopId
        }).then((res) => {
          if (res.status === 200) {
            let data = res.data
            if (data.code === 0) {
              this.searchProductById(this.state.current, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
              message.success('下架成功')
            } else if (data.code === 50) {
              message.error(data.msg)
              removeToken();
            } else {
              message.error(data.msg)
              this.setState({
                deleteVisible: false
              })
            }
          }
        }).catch(error => {
          message.error(error.toString())
        })
        break;
    }
  }

  showModalUpdatePrice = () => {
    if (this.state.selectedRowKeys.length === 0) {
      return message.error("请先选择商品", 1)
    }
    this.setState({
      updateStockVisible: true,
    });
  };

  changeInputStock = e => {
    const {value} = e.target;
    this.setState({inputProductStock: value})
  }

  onHandleUpdateStockOk = (e) => {
    getProductStockBatch({
      ids: this.state.selectedRowKeys,
      shopId: this.state.shopId,
      stockCount: this.state.inputProductStock,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success('批量修改库存成功')
          this.setState({
            updateStockVisible: false,
          }, ()=>{
            // this.searchProductById(this.state.current, this.state.tempCategoryId, '', '', this.state.pageSize)
            window.location.reload(true)
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }
  onHandleUpdateStockCancel = (e) => {
    this.setState({
      updateStockVisible: false,
    });
  }

  recommend=(productId,value)=>{
    if (value==true){
      getRecommend({
        id:productId
      }).then((res) => {
        if (res.status === 200) {
          let data = res.data
          if (data.code === 0) {
            this.searchProductById(1, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
            message.success("推荐成功")
          } else if (data.code === 50) {
            this.searchProductById(1, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
            message.error(data.msg)
          } else {
            this.searchProductById(1, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
            message.error(data.msg)
          }
        }
      }).catch(error => {
        message.error(error.toString())
      })
    }
    if (value==false){
      noRecommend({
        id:productId
      }).then((res) => {
        if (res.status === 200) {
          let data = res.data
          if (data.code === 0) {
            this.searchProductById(1, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
            message.success("已取消")
          } else if (data.code === 50) {
            this.searchProductById(1, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
            message.error(data.msg)
          } else {
            this.searchProductById(1, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)
            message.error(data.msg)
          }
        }
      }).catch(error => {
        message.error(error.toString())
      })
    }
  }

  render() {
    const _this = this
    const columnsP = [
      {
        title: '商品',
        dataIndex: 'product',
        render: (text, record) => (
          <div>
            {
              <div
                style={{height: 70, display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                <img style={{width: 70, height: 70, cursor: "pointer"}} src={record.imagePath}
                onClick={_this.showBigImg.bind(this, record.imagePath)}/>
                <div style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginLeft: "2px",
                }}>{
                  record.productName
                  // this.state.platformType == 5 ?
                  //   <Input.TextArea
                  //     defaultValue={record.productName}
                  //     style={{width: '420px', border: "solid 1px #eaeaea"}}
                  //     maxLength = {50}
                  //     onChange={(e) => this.setState({tempProductName: e.target.value})}
                  //     onKeyDown={
                  //       this.onTextChange.bind(this, 'goods', record)
                  //     }
                  //     onBlur={this.onBlurShelfNumber.bind(this, 'goods', record)}
                  //   /> : record.productName
                }
                </div>
              </div>
            }
          </div>
        ),
      },
      {
        title: '价格',
        dataIndex: 'price',
        sorter: (a, b) => a.price- b.price,
        render: (text, record) => (
          <div>
            {
              <Input
                  defaultValue={record.price}
                  style={{width: '100px', border: "0"}}
                  onChange={(e) => this.setState({tempProductPrice: e.target.value})}
                  onKeyDown={
                    this.onTextChange.bind(this, 'price', record)
                  }
                  onBlur={this.onBlurShelfNumber.bind(this, 'price', record)}
              />
            }
          </div>
        ),
      },
      {
        title: '销量',
        dataIndex: 'sellCount'
      },
      {
        title: '库存',
        dataIndex: 'stock',
        render: (text, record) => (
            <div>
              {
                <Input
                    defaultValue={record.stock}
                    style={{width: '100px', border: "0"}}
                    onChange={(e) => this.setState({tempProductStock: e.target.value})}
                    onKeyDown={
                      this.onTextChange.bind(this, 'stock', record)
                    }
                    onBlur={this.onBlurShelfNumber.bind(this, 'stock', record)}
                />
              }
            </div>
        ),
      },
      {
        title: '操作',
        dataIndex: 'option',
        render: (text, record) => (
          <Space size="middle">
            <Link to={{
              pathname: COMMON_ROUTER + `/goods/edit-goods`,
              state: {
                shopId: this.state.shopId,
                id: record.productId,
                tempCategoryId: this.state.tempCategoryId
              }
            }}><span>编辑</span></Link>


            {
              record.dataStatus === 0 ?
                <a onClick={_this.onShowModal.bind(this, 'onShelf', record.categoryId, record.productId)}>上架</a> :
                <a style={{color: "#ff9900"}} onClick={_this.onShowModal.bind(this, 'soldOut', record.categoryId, record.productId)}>下架</a>
            }
            <a style={{color: "#eb2509"}}
               onClick={_this.onShowModal.bind(this, 'delete', record.categoryId, record.productId)}>删除</a>
            <Switch checkedChildren="推荐"
                    unCheckedChildren="关闭"
                    // checked={_this.state.switchChecked}
                    checked={record.sortNum == 0 ? false: true}
                    onChange={_this.recommend.bind(this,record.productId)}
            />
          </Space>
        ),
      },
    ];
    const columnsLogs = [
      {
        title: "同步ID",
        dataIndex: 'dataSynchroHistoryId',
        width: 100
      },
      {
        title: "操作类型",
        dataIndex: 'operationName',
        width: 160,
        // ellipsis: true
      },
      {
        title: "操作内容",
        dataIndex: 'operationContent',
        width: 200,
        // ellipsis: true
      },
      {
        title: "状态码",
        dataIndex: 'dataStatusName',
        width: 100,
        ellipsis: true
      },
      {
        title:"开始时间",
        dataIndex: 'addTime',
        width: 160,
        ellipsis: true
      },
      {
        title:"结束时间",
        dataIndex: 'updateTime',
        width: 160,
        ellipsis: true
      },
      {
        title: "操作结果",
        dataIndex: 'operationResult',
        // width: 800,
        // ellipsis: true
      }
    ];
    const {selectedRowKeys, category, categoryProduct} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    const formItemLayout = {
      labelCol: {
        xs: 24,
        sm: 4
      },
      wrapperCol: {
        xs: 24,
        sm: 12
      }
    }

    return (
      <div style={{width: "100%"}}>
        <Row className="container-goods">
          <Col span="5" className="goods-left1">
            {/*<ReactSortable*/}
            {/*  style={{padding: "15px", height: "700px", overflow: 'auto'}}*/}
            {/*  list={category}*/}
            {/*  setList={newState => {*/}
            {/*    this.setState({category: newState})*/}
            {/*  }}*/}
            {/*>*/}
            <div style={{padding: "15px", height: "700px", overflow: 'auto'}}>
              {this.state.category.map(item => (
                <div style={{height: '30px', lineHeight: "30px", fontSize: "15px"}} key={item.categoryId}
                     className="goods-left-item">
                  <span className="goods-left-item-txt"
                        onClick={this.searchProductById.bind(this, 1, item.categoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)}>{item.categoryName}</span>
                  <Space>
                    <a onClick={this.onShowEditCateModal.bind(this, item.categoryId)}>编辑</a>
                    <a style={{color: "#ff4d4f"}} onClick={this.onShowDelCateModal.bind(this, item.categoryId)}>删除</a>
                  </Space>
                  {
                    this.state.tempCategoryId === item.categoryId ?
                      <div style={{width: '10px'}}><CheckOutlined/></div>
                      :
                      <span style={{width: '10px'}}/>
                  }
                </div>
              ))}
            </div>
            {/*</ReactSortable>*/}

            {/*<List*/}
            {/*  size="small"*/}
            {/*  split={false}*/}
            {/*  dataSource={category}*/}
            {/*  style={{padding: "15px", height: "660px", overflow: 'auto'}}*/}
            {/*  renderItem={item => <List.Item>*/}
            {/*    <div style={{height: '30px', lineHeight: "30px", fontSize: "15px"}} key={item.categoryId}*/}
            {/*         className="goods-left-item">*/}
            {/*      <span className="goods-left-item-txt"*/}
            {/*            onClick={this.searchProductById.bind(this, 1, item.categoryId, '', '', this.state.pageSize)}>{item.categoryName}</span>*/}
            {/*      <Space>*/}
            {/*        <a onClick={this.onShowEditCateModal.bind(this, item.categoryId)}>编辑</a>*/}
            {/*        <a style={{color: "#ff4d4f"}} onClick={this.onShowDelCateModal.bind(this, item.categoryId)}>删除</a>*/}
            {/*      </Space>*/}
            {/*      {*/}
            {/*        this.state.tempCategoryId === item.categoryId ?*/}
            {/*            <div style={{width: '10px'}}><CheckOutlined/></div>*/}
            {/*            :*/}
            {/*            <span style={{width: '10px'}}/>*/}
            {/*      }*/}
            {/*    </div>*/}
            {/*  </List.Item>}*/}
            {/*/>*/}

            <div className="category-create-save">
              <Button type="primary" onClick={this.showModal}>
                新建分类
              </Button>
            </div>
          </Col>
          <Col span="19" className="goods-right1">
            <div className="goods-option2">
              <div className="goods-option-top">
                <Input style={{width: '150px', marginRight: "5px"}} value={this.state.inputProductName}
                       onChange={this.changeInputName} placeholder="请输入商品名称"/>
                <Button style={{marginLeft: '5px', marginRight: '0px'}} shape="round" type="primary"
                        onClick={this.searchProductById.bind(this, 1, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)}>
                  搜索
                </Button>
              </div>

              <div className="goods-option-top">
                {/*<div style={{marginRight: '30px', marginLeft: '30px'}} onClick={this.showLog}>*/}
                {/*  <BellOutlined style={{ fontSize: '14px', color: '#0b68d4' }} />*/}
                {/*  <a>任务进度</a>*/}
                {/*</div>*/}

                {/*{*/}
                {/*  this.state.isSort ? <Button onClick={this.hideSort} shape="round">取消排序</Button> : null*/}
                {/*}*/}
                {/*{*/}
                {/*  this.state.isSort ?*/}
                {/*      <Button style={{marginLeft: '2px', marginRight: '20px'}} type="primary" shape="round" loading={loadingSort} onClick={this.showSortSave}>保存</Button>*/}
                {/*      :*/}
                {/*      <Button style={{marginLeft: '2px', marginRight: '20px'}} type="primary" shape="round" onClick={this.showSort}>排序</Button>*/}
                {/*}*/}

                <span style={{marginLeft: '20px'}}><Button type="primary" shape="round" onClick={this.showModalUpdatePrice}>批量改库存</Button></span>
                <span style={{marginLeft: '20px'}}><Button type="primary" shape="round" onClick={this.onBathShelfSoldout.bind(this, 'onShelf')}>批量上架</Button></span>
                <span style={{marginLeft: '10px', marginRight: '50px'}}><Button type="primary" shape="round" onClick={this.onBathShelfSoldout.bind(this, 'soldOut')}>批量下架</Button></span>

                <span style={{marginLeft: '5px'}}>
                     <Button onClick={this.addShop} type="primary" shape="round">新建商品</Button>
                </span>
              </div>
            </div>
            <div className="goods-option-top-down">
            </div>
            {
              this.state.isSort ?
                  <ReactSortable
                      style={{padding: "15px", height: "700px", overflow: 'auto'}}
                      list={categoryProduct}
                      setList={newState => {
                        this.setState({categoryProduct: newState})
                      }}
                  >
                    {categoryProduct.map((item, index) => (
                        <div key={item.productId}>
                          <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
                          <div className="goods-sort">
                            <div style={{height: 40, display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                              <img style={{width: 40, height: 40}} src={item.imageUrl}/>
                              <div style={{textAlign: "start",display: "flex",flexDirection: "row",alignItems: "center",marginLeft: "10px",}}>
                                {item.productName}
                              </div>
                            </div>
                            <div className="goods-sort">
                              <span style={{marginRight: '60px'}}>价格：{item.price}</span>
                              <span style={{marginRight: '50px'}}>条形码：{item.barCode}</span>
                              <InputNumber style={{marginRight: '50px'}} min={1} max={this.state.pageSize} value={index + 1}
                                           blur={(e) => console.log(e.target.value)}
                                           // onChange={this.onChangeInputSort}
                                           onPressEnter={this.onPressEnterSort.bind(this, item, index)} />
                              <span style={{marginRight: '10px'}}><OrderedListOutlined /> 拖动排序</span>
                              <a onClick={this.sortFirst.bind(this, item, index)}>置顶</a>
                            </div>
                          </div>
                        </div>
                    ))}
                  </ReactSortable>
                  :
                  <ConfigProvider locale={zhCN}>
                    <div>
                      <Table rowKey={"productId"}
                             rowSelection={rowSelection}
                             columns={columnsP}
                          // pagination={{
                          //   hideOnSinglePage: true
                          // }}
                             onChange={this.onChangeSort}
                             pagination={false}
                             dataSource={categoryProduct}/>

                      <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        padding: "0 20px 0 0"
                      }}>
                        <Pagination style={{marginTop: 20}} showQuickJumper={true} showSizeChanger={true}
                                    onShowSizeChange={this.onChangePageSize.bind(this)}
                                    current={this.state.current} pageSize={this.state.pageSize} total={this.state.total}
                                    onChange={this.onChangePage.bind(this)}/>
                      </div>

                    </div>
                  </ConfigProvider>
            }
          </Col>
        </Row>

        <Modal
          title={this.state.modalType}
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="确认"
          cancelText="取消"
        >
          <Form layout="horizontal">
            <Form.Item
              {...formItemLayout}

              label="分类名称"
              rules={[
                {
                  required: true,
                  message: '请输入分类名称',
                },
              ]}
            >
              <Input value={_this.state.categoryName} onChange={this.changeCategory} placeholder="请输入分类名称"/>
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                label="分类排序"
                rules={[
                  {
                    required: true,
                    message: '请输入排序号',
                  },
                ]}
            >
              <Input value={_this.state.sortNum} onChange={this.changeSort} placeholder="请输入排序号"/>
            </Form.Item>

            <Form.Item {...formItemLayout} label="分类描述">
              <Input.TextArea value={_this.state.categoryDesc} onChange={this.changeCategoryDetail}/>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          visible={this.state.delete1Visible}
          onOk={this.onHandleOk.bind(this, 'delete1')}
          onCancel={this.onHandleCancel.bind(this, 'delete1')}
          okText="确认"
          cancelText="取消"
        >
          确定将商品删除嘛？
        </Modal>
        <Modal
            visible={this.state.deleteVisible}
            onOk={this.onHandleDelOk.bind(this)}
            onCancel={this.onHandleDelCancel.bind(this)}
            okText="直接删除"
            cancelText="放入回收站"
            footer={null}
        >
          <div>
            <span>真的要将商品删除嘛？</span>
            <div style={{display: 'flex', flexDirection: 'row',justifyContent: 'flex-end', alignItems: 'center', marignTop: 20}}>
              <Button style={{marginRight: 20}} onClick={this.onHandleCancel.bind(this, 'delete')}>取消</Button>
              <Button type="primary" onClick={this.onHandleOk.bind(this, 'delete')}>确认</Button>
            </div>
          </div>
        </Modal>

        <Modal
            visible={this.state.delCateVisible}
            onOk={this.onHandleDelCateOk.bind(this)}
            onCancel={this.onHandleDelCateCancel.bind(this)}
            confirmLoading={this.state.loadingDelCate}
            okText="确认"
            cancelText="取消"
        >
          确定将该分类删除嘛？
        </Modal>


        <Modal
            width={'480px'}
            visible={this.state.bigImgVisible}
            onOk={this.onHandleImgOk.bind(this)}
            onCancel={this.onHandleImgCancel.bind(this)}
            okText="确认"
            cancelText="取消"
            footer={null}
        >
          <div style={{width: '100%', height: '400px'}}>
            <img style={{width: '400px', height: '400px'}} src={this.state.bigImgUrl} />
          </div>
        </Modal>

        {/*<Modal*/}
        {/*    title="推送日志"*/}
        {/*    width={'80%'}*/}
        {/*    visible={this.state.logVisible}*/}
        {/*    onOk={this.onHandleLogOk.bind(this)}*/}
        {/*    onCancel={this.onHandleLogCancel.bind(this)}*/}
        {/*    okText="确认"*/}
        {/*    cancelText="取消"*/}
        {/*    footer={null}*/}
        {/*>*/}
        {/*  <div style={{width: '100%', padding: '0 0 30px 0'}}>*/}
        {/*    <Table*/}
        {/*        rowKey={'dataSynchroHistoryId'}*/}
        {/*        dataSource={this.state.logList}*/}
        {/*        columns={columnsLogs}*/}
        {/*        pagination={false}*/}
        {/*        size='default'*/}
        {/*    />*/}
        {/*    <ConfigProvider locale={zhCN}>*/}
        {/*      <div style={{float: 'right'}}>*/}
        {/*        <Pagination style={{marginTop: 5}} showQuickJumper={true} onShowSizeChange={this.onChangeSizeLog}*/}
        {/*                    current={this.state.logCurrent} pageSize={this.state.logPagesize} total={this.state.logTotal}*/}
        {/*                    onChange={this.onChangePageLog}/>*/}
        {/*      </div>*/}
        {/*    </ConfigProvider>*/}
        {/*  </div>*/}
        {/*</Modal>*/}

        <Modal
            title="批量改价"
            width={'32%'}
            visible={this.state.updateStockVisible}
            onOk={this.onHandleUpdateStockOk.bind(this)}
            onCancel={this.onHandleUpdateStockCancel.bind(this)}
            okText="确认"
            cancelText="取消"
        >
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <span style={{color: '#000000', fontWeight: 'bold'}}>改库存：<Input style={{width: '150px', marginLeft: '10px'}} value={this.state.inputProductStock} onChange={this.changeInputStock}
                                                                           placeholder="请输入库存"/></span>
            <span style={{color: '#868686', marginLeft: '50px', marginTop: '5px'}}>注：加库存为正数，减库存为负数，例如：加10个库存：<span style={{color: '#ff0000'}}>10</span>，减10个库存：<span style={{color: '#ff0000'}}>-10</span></span>
          </div>
        </Modal>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/pages/goods/index.js